import useAppI18n from './use-app-i18n';
import { useToast } from 'primevue/usetoast';
import { AppCoreEnums } from '../shared/enums';
import { ToastMessageOptions } from 'primevue/toast';
import { AppToastMessageOptions, ToastNotificationAction } from '@/stores/core/models';

export default () => {
  const { t } = useAppI18n();
  const toast = useToast();

  const showError = (msg: string, title: string) => {
    toast.add({
      summary: t(title),
      detail: t(msg),
      severity: 'error',
      life: 10000,
      type: AppCoreEnums.ToastNotificationType.Error,
    } as AppToastMessageOptions);
  };

  const showSuccess = (
    msg: string,
    title: string,
    count: number = 1,
    customAction: ToastNotificationAction | undefined = undefined
  ) => {
    toast.add({
      summary: t(title, count),
      detail: t(msg, count),
      severity: 'success',
      life: 10000,
      customAction: customAction,
      type: AppCoreEnums.ToastNotificationType.Success,
    } as AppToastMessageOptions);
  };

  const showUserFeeling = (
    msg: string,
    title: string,
    title2: string | undefined = undefined,
    msg2: string | undefined = undefined,
    count: number = 1,
    customAction: ToastNotificationAction | undefined = undefined
  ) => {
    toast.add({
      summary: t(title, count),
      summary2: title2 ? t(title2, count) : undefined,
      detail: t(msg, count),
      detail2: msg2 ? t(msg2, count) : undefined,
      severity: 'feedback',
      life: 0,
      customAction: customAction,
      type: AppCoreEnums.ToastNotificationType.UserFeeling,
    } as AppToastMessageOptions);
  };

   const showUserFeelingThanks = (
    msg: string,
    title: string,
    count: number = 1,
    customAction: ToastNotificationAction | undefined = undefined,
    feedbackValue: AppCoreEnums.UserFeelingFeedback | undefined = undefined,
  ) => {
    toast.add({
      summary: t(title, count),
      detail: t(msg, count),
      severity: 'feedback',
      life: 3000,
      customAction: customAction,
      type: AppCoreEnums.ToastNotificationType.UserFeelingThanks,
      feedbackValue: feedbackValue,
    } as AppToastMessageOptions);
  };

  const showWarn = (msg: string, title: string) => {
    toast.add({
      summary: t(title),
      detail: t(msg),
      severity: 'warn',
      life: 10000,
      customAction: undefined,
      type: AppCoreEnums.ToastNotificationType.Warning,
    } as AppToastMessageOptions);
  };

  const hideNotification = (msg: ToastMessageOptions) => {
    toast.remove(msg);
  };

  return {
    showWarn,
    showError,
    showSuccess,
    showUserFeeling,
    showUserFeelingThanks,
    hideNotification,
  };
};
